const numberFormat = (value, currency = 'BRL') => {
  if (!value) return 0
  let myValue = `${value}`

  let minimumFractionDigits = 2
  let maximumFractionDigits = 2

  const sliceValue = (until) => {
    const [beforeDot, afterDot = ''] = myValue.split('.')
    return value !== 0 ? `${beforeDot}.${afterDot.slice(0, until)}` : myValue
  }

  if (currency === 'BTC' || currency === 'ETH') {
    maximumFractionDigits = 8
    minimumFractionDigits = 8
    myValue = sliceValue(maximumFractionDigits)

    if (myValue.includes('.')) {
      let myValueSplited = myValue.split('.')
      const needWhatNumbers = 8 - myValueSplited[1].length

      if (needWhatNumbers > 0) {
          const numbersNeeded = Array.from(Array(needWhatNumbers)).fill('0')

          const newMyValue = [myValueSplited[0], `${myValueSplited[1]}${numbersNeeded.join('')}`]
          myValue = newMyValue.join(',')

          return myValue
      }
    }
  }

  if(currency === 'USDT' || currency === 'USDC'){
      maximumFractionDigits = 4
      minimumFractionDigits = 4
      myValue = sliceValue(maximumFractionDigits)
  }

  if(value === 0){
    maximumFractionDigits = 0
    minimumFractionDigits = 0
  }

  return new Intl.NumberFormat('pt-Br', { maximumFractionDigits, minimumFractionDigits }).format(parseFloat(myValue))
}

export default numberFormat
